import BaseCard from './baseCard.js';
export default BaseCard;